import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "./inventory.css";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import BackIcon from "../../../assets/communication/Back.svg";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import * as XLSX from 'xlsx';
import { REWARDS_DEFINITION_ADD, REWARDS_INVENTORY_LIST } from "../../../routes";
import { fetchRewardDefinitionDetail, fetchRewardRedemptionExportList, fetchRewardRedemptionList } from "../../../store/campaign";
import momentTZ from 'moment-timezone';
import ExportIcon from "../../../assets/rewards/export.svg";
import moment from "moment/moment";
import RewardRedemptionSortableTable from "./reward_redemption_sortable_table";

const INVENTORY_TAB = {
  INVENTORY_INFO: "Info",
  INVENTORY_REDEMPTION: "Redemption",
};

export const RewardDefinitionDetail = () => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const id = query.get("id");

  const [inventoryTab, setInventoryTab] = useState(INVENTORY_TAB.INVENTORY_INFO);
  const [detailData, setDetailData] = useState({});
  const [detailLoading, setDetailLoading] = useState(false);
  const { redemption_list, redemption_export_list } = useSelector(
    (state) => state.campaigns
  );


  const today = new Date();


  const userPermissions = getUserPermission();

  const viewPermssion = checkPermission(
    userPermissions,
    "gamifications.access_reward"
  );

  const getData = async () => {
    setDetailLoading(true);
    dispatch(fetchRewardDefinitionDetail(id)).then((detail) => {
      setDetailData(detail.payload);
      getRedemptionData();
    });

  };

  const getRedemptionData = async () => {

    // if (dateRange.start && dateRange.end) {
    setDetailLoading(true);


    dispatch(fetchRewardRedemptionList({ id: id })).then((operatorRes) => {
      setDetailLoading(false);
    });
    // }

  };

  const getRedemptionExportData = async () => {
    setDetailLoading(true);


    dispatch(fetchRewardRedemptionExportList({ id: id })).then((res) => {
      setDetailLoading(false);

      const formattedData = convertDates(res.payload);

      const worksheet = XLSX.utils.aoa_to_sheet(formattedData);

      // Set column widths: array of objects with width in characters
      worksheet['!cols'] = [
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Redemption List");
      XLSX.writeFile(workbook, "Redemption_List.xlsx");
    });

  };

  // Function to detect ISO date string (simple check)
  const isIsoDateString = (value) =>
    typeof value === "string" && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value);

  // Convert all dates using momentTZ and your format
  const convertDates = (dataArray) =>
    dataArray.map((row) =>
      Array.isArray(row)
        ? row.map((cell) =>
          isIsoDateString(cell)
            ? momentTZ.tz(cell, "Asia/Singapore").local().format("DD-MM-YYYY hh:mm A")
            : cell
        )
        : row  // return non-array row as is, e.g. "" or other values
    );




  const exportToXlsx = (data, fileName) => {
    console.log(data);
    const wb = XLSX.utils.book_new(); // Create a new workbook
    const sheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, sheet);
    XLSX.writeFile(wb, `${fileName}.xlsx`); // Save the file
  };


  useEffect(() => {
    getData();
  }, [id]);





  const onTabChange = (tab) => {
    setInventoryTab(tab);
  };



  const InventoryInfoView = (() => {

    return (
      <div className="">
        <div style={{ margin: "10px" }} className="margin-bottom">

          {detailData.name ? (<div className="inventory_detail_child_box_main_detail_items">
            <div className="inventory_detail_child_box_main_detail_items_title inventory_detail_center_item detail_padding_bottom">
              Reward Name
            </div>
            <div className="inventory_detail_child_box_main_detail_items_splitter" />
            <div className="inventory_detail_center_item inventory_detail_child_box_main_detail_items_subdetail detail_padding_bottom">

              <a
                href={`${REWARDS_DEFINITION_ADD}?id=${id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inventory-hyper-link"
              >
                {detailData.reward_name}
              </a>

            </div>
          </div>
          ) : (
            <div></div>
          )}

          <RenderRow
            title={"Image"}
            value={detailData.images?.length > 0 ? detailData.images[0].url : ''}
            isImage={true}
          />

          <RenderRow
            title={"Reward Partner"}
            value={detailData.provider_name || ''}
            isImage={false}
          />

          <RenderRow
            title={"Start Date & Time"}
            value={detailData.start_date && detailData.start_time ? momentTZ.tz(`${detailData.start_date} ${detailData.start_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
            isImage={false}
          />

          <RenderRow
            title={"End Date & Time"}
            value={detailData.end_date && detailData.end_time ? momentTZ.tz(`${detailData.end_date} ${detailData.end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
            isImage={false}
          />


          <RenderRow
            title={"Points/coupon"}
            value={detailData.point_cost || ''}
            isImage={false}
          />

          <RenderRow
            title={"Total qty"}
            value={detailData.total_quota || ''}
            isImage={false}
          />

          <RenderRow
            title={"Reward Type"}
            value={detailData.reward_type || ''}
            isImage={false}
          />

          <RenderRow
            title={"Reward Value"}
            value={detailData.reward_value || ''}
            isImage={false}
          />

          <RenderRow
            title={"Collection details"}
            value={detailData.collection_details || ''}
            isImage={false}
          />

          <RenderRow
            title={"What to Bring"}
            value={detailData.what_to_bring || ''}
            isImage={false}
          />

          <RenderRow
            title={"Important Notes"}
            value={detailData.important_notes || ''}
            isImage={false}
          />

          <RenderRow
            title={"URL"}
            value={detailData.link || ''}
            isImage={false}
          />

          <RenderRow
            title={"Created By"}
            value={detailData.created_by?.name || ''}
            isImage={false}
          />

          <RenderRow
            title={"Created On"}
            value={detailData.created_on ? momentTZ.tz(`${detailData.created_on}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
            isImage={false}
          />






        </div>

      </div>
    );
  });


  const RenderRow = ({ title, value, isImage }) => {
    return (
      <>
        {value ? (
          <>
            <div className="inventory_detail_child_box_main_detail_items">
              <div className="inventory_detail_child_box_main_detail_items_title inventory_detail_center_item detail_padding_bottom">
                {title}
              </div>
              <div className="inventory_detail_child_box_main_detail_items_splitter" />
              <div className="inventory_detail_center_item inventory_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                {isImage ? (
                  <>
                    <img
                      style={{ height: "200px" }}
                      src={value}
                    />
                  </>
                ) : (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: value }} />
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };



  return (
    <>
      {viewPermssion ? (
        <div className="inventory_container">

          {
            detailLoading && (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100% - 75px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            )
          }
          <div className="inventory_child_box">

            <div className="inventory_body">
              <div className="inventory_addheader" >
                <div className="back-title-group" onClick={(e) => {
                  navigate(REWARDS_INVENTORY_LIST);

                }}>
                  <img src={BackIcon} className="back-icon" />
                  <span className="back-text">Back</span>
                </div>

                {inventoryTab == INVENTORY_TAB.INVENTORY_REDEMPTION &&
                  (<div
                    className="inventory-export-btn"
                    onClick={() => {
                      getRedemptionExportData();
                    }}>
                    <img src={ExportIcon} />
                    Export
                  </div>)}
              </div>
            </div >

            <div className="inventory_scroll_box_detail">

              <div className="flex-between">
                <div className="inventory_tab_content">
                  <div className="tabs">
                    <div
                      onClick={() => onTabChange(INVENTORY_TAB.INVENTORY_INFO)}
                      className={`tab ${inventoryTab === INVENTORY_TAB.INVENTORY_INFO ? "isactive" : ""
                        }`}
                    >
                      {INVENTORY_TAB.INVENTORY_INFO}
                    </div>
                    <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
                    <div
                      onClick={() => onTabChange(INVENTORY_TAB.INVENTORY_REDEMPTION)}
                      className={`tab ${inventoryTab === INVENTORY_TAB.INVENTORY_REDEMPTION ? "isactive" : ""
                        }`}
                    >
                      {INVENTORY_TAB.INVENTORY_REDEMPTION}
                    </div>

                  </div>

                </div>

              </div>



              <div className="inventory_items_list">
                {inventoryTab == INVENTORY_TAB.INVENTORY_INFO ? (
                  <InventoryInfoView />
                ) : (
                  <div>

                    <div style={{ maxHeight: '70%', overflow: 'auto' }}>

                      <RewardRedemptionSortableTable data={redemption_list} />

                    </div>
                  </div>
                )


                }

              </div>
            </div>



          </div>

        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}

    </>
  );
};
